import React from 'react';
import { SubscriptionDetailsTab } from './components/tabs/SubscriptionDetailsTab';
import { ClerkOrganizationProfileTab } from './components/tabs/ClerkOrganizationProfileTab';
import BasicTabs from '../../common/basic-tabs/BasicTabs';
import { useTranslation } from 'react-i18next';
import { Typography, Stack, Box } from '@mui/material';
import styles from './Settings.module.scss';
import { NoCompanyRedirect } from '../../common/no-company-redirect/NoCompanyRedirect';
import { useSearchParams } from 'react-router-dom';

const SettingsPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  const tabs = [t('headers.administration'), t('settings.titles.plan')];
  const tabContents = [
    <>
      <NoCompanyRedirect>
        <ClerkOrganizationProfileTab key={0} />
      </NoCompanyRedirect>
    </>,
    <SubscriptionDetailsTab key={1} />,
  ];

  return (
    <>
      <Box sx={{ mt: '-78px' }}>
        <Box sx={{ pt: '16px !important' }}>
          <Stack spacing={0} sx={{ width: '50%', marginBottom: '20px' }}>
            <Typography variant='h5' component='h1' className={styles.page_title}>
              {t('headers.settings')}
            </Typography>
          </Stack>
        </Box>
        <BasicTabs
          tabs={tabs}
          tabContents={tabContents}
          activeTab={tab === 'subscription' ? 1 : 0}
        />
      </Box>
    </>
  );
};
export default SettingsPage;
